import { routePermissions } from "@/constants/permission-user"

export const routesSettings = [
  {
    path: "/global-settings/customer-permission",
    name: "customerPermission",
    component: () => import("@/views/globalSetting/CustomerPermission.vue"),
    meta: {
      module: "globalSettings",
      pageTitle: "Customer Permission",
      breadcrumb: [
        {
          text: "Customer Permission",
          active: true,
        },
      ],
    },
  },
  {
    path: "/global-settings",
    name: "globalSettings",
    component: () => import("@/views/globalSetting/GlobalSetting.vue"),
    meta: {
      module: "globalSettings",
      pageTitle: "Settings",
      breadcrumb: [
        {
          text: "Settings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/global-settings/data-management/service",
    name: "serviceManagement",
    component: () =>
      import(
        "@/views/globalSetting/dataManagement/service/ServiceDataManagement.vue"
      ),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Service Data Management",
      breadcrumb: [
        {
          text: "Service Data Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/global-settings/data-management/service/create",
    name: "createNewService",
    component: () =>
      import("@/views/globalSetting/dataManagement/service/AddServiceData.vue"),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Create New Service",
      breadcrumb: [
        {
          text: "Service Data Management",
          active: false,
          to: "/global-settings/data-management/service",
        },
        {
          text: "Create New Service",
          active: true,
        },
      ],
      navActiveLink: "serviceManagement",
    },
  },
  {
    path: "/global-settings/data-management/service/:serviceId",
    name: "serviceDetail",
    component: () =>
      import(
        "@/views/globalSetting/dataManagement/service/EditServiceData.vue"
      ),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Service Detail",
      breadcrumb: [
        {
          text: "Service Data Management",
          active: false,
          to: "/global-settings/data-management/service",
        },
        {
          text: "Service Detail",
          active: true,
        },
      ],
      navActiveLink: "serviceManagement",
    },
  },
  {
    path: "/global-settings/data-management/ticket-topic",
    name: "addTicketTopicData",
    component: () =>
      import(
        "@/views/globalSetting/dataManagement/ticket/TicketTopicDataManagement.vue"
      ),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Ticket Topic Data Management",
      breadcrumb: [
        {
          text: "Ticket Topic Data Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/global-settings/data-management/ticket-reply-template",
    name: "addTicketReplyTemplateData",
    component: () =>
      import(
        "@/views/globalSetting/dataManagement/ticket/TicketReplyTemplateDataManagement.vue"
      ),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Ticket Reply Template Management",
      breadcrumb: [
        {
          text: "Ticket Reply Template Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/global-settings/data-management/location",
    name: "locationManagement",
    component: () =>
      import("@/views/globalSetting/dataManagement/site/SiteManagement.vue"),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Location Management",
      type: "internal",
      breadcrumb: [
        {
          text: "Location Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/global-settings/data-management/location/:siteId",
    name: "locationDetail",
    component: () =>
      import("@/views/globalSetting/dataManagement/site/SiteCreateEdit.vue"),
    meta: {
      module: "globalSettingsDataManagement",
      pageTitle: "Location Detail",
      type: "internal",
      breadcrumb: [
        {
          text: "Location Management",
          active: false,
          to: "/global-settings/data-management/location",
        },
        {
          text: "Location Detail",
          active: true,
        },
      ],
      navActiveLink: "locationManagement",
    },
  },
].map((route) => {
  return {
    ...route,
    meta: {
      ...route.meta,
      type: "internal",
      permission: routePermissions[route.name],
    },
  }
})
